const INITIAL_STATE = [];

export default function notifications(state = INITIAL_STATE, { type, payload }) {
  switch (type) {
    case 'data-load_FULFILLED': {
      if (payload && payload.key === 'notifications') {
        // console.log('perfObj ====>', payload.response.data);
        return payload.response.data.data;
      }

      return state;
    }

    default:
      return state;
  }
}
